const ChairishContext = window.chairisher.context;

/**
 * @returns {Array.<Object>} A collection of carousel story objects; contains link, summary, title etc.
 */
export default function getCarouselStories() {
    return ChairishContext.carouselStoriesArray || [];
}
